'use strict';

import {getJSON} from '../xhr';
import event from '../event';

export default function load(files, cb) {
    if (files.length === 0) {
        cb();
        return;
    }

    let downloadCount = 0;
    let error;

    files.forEach((file) => {
        if (file.json) {
            doCallback(null, file);
        } else if (file.url) {
            getJSON(file.url, (err, json) => {
                file.json = json;
                doCallback(err, file);
            });
        }
    });

    function doCallback(err, file) {
        downloadCount++;
        error = err || error;
        event.trigger(err ? 'error.file.i18n' : 'load.file.i18n', {error: err, file});

        if (downloadCount === files.length) {
            cb(error);
        }
    }
}
